var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base-close-button",class:_vm.disabled ? 'disabled' : '',attrs:{"disabled":_vm.disabled},on:{"click":_vm.emitClick}},[_c('Icon',{attrs:{"name":"closebtn"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }